import {observer} from 'mobx-react';
import React from 'react';
import s from '../../s';
import {Swiper, SwiperSlide} from 'swiper/react';
import {Keyboard, Navigation} from 'swiper/modules';
import 'swiper/scss';
import 'swiper/scss/navigation';
import ProductItem from './product-item';

export type RelatedProduct = {
    id: number;
    src: string;
    link: string;
    price: number;
};

// just for testing purposes, will be removed in phase 2
const price = 199.95;
const link = 'https://www.diplomaframe.com/corn/masterpiece-medallion-diploma-frame-15277.aspx';
const src = 'https://img.diplomaframe.com/i/0_200_300_1_143_375_36_0_4_1088_0___0____0__11.000_0_8.500_0_0_0_0.png';
const relatedProducts: RelatedProduct[] = [
    {id: 1, src, price, link},
    {id: 2, src, price, link},
    {id: 3, src, price, link},
    {id: 4, src, price, link},
    {id: 5, src, price, link},
    {id: 6, src, price, link},
    {id: 7, src, price, link},
    {id: 8, src, price, link},
    {id: 9, src, price, link},
    {id: 10, src, price, link},
];

const RelatedProducts: React.FC = observer(() => {
    if (!s.ready) {
        return null;
    }

    return (
        <div id="related-products">
            <div
                className="prod-sub-header toggle-bs"
                id="related-products-click"
                role="button"
                data-bs-toggle="collapse"
                data-bs-target="#related-products-main"
                aria-controls="related-products-main"
                tabIndex={0}
                aria-expanded={false}
            >
                Related Products
            </div>
            <div
                id="related-products-main"
                className="collapse show mt-3 plh"
            >
                <Swiper
                    id="related-products-swiper"
                    grabCursor={true}
                    loop={true}
                    keyboard={{enabled: true}}
                    navigation={true}
                    spaceBetween={20}
                    updateOnWindowResize={true}
                    breakpoints={{
                        1150: {
                            slidesPerView: 5,
                        },
                        850: {
                            slidesPerView: 4,
                        },
                        620: {
                            slidesPerView: 3,
                        },
                        350: {
                            slidesPerView: 2,
                        },
                        0: {
                            slidesPerView: 1,
                        },
                    }}
                    modules={[Keyboard, Navigation]}
                    className="related-products-swiper"
                    aria-roledescription="carousel"
                    role="region"
                    aria-label="Product images"
                >
                    {relatedProducts.map((p, i) => (
                        <SwiperSlide key={i}>
                            <ProductItem product={p} />
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    );
});

export default RelatedProducts;
